import { useEffect } from 'react';
import useAgentStore from '../components/pages/useAgentStore';

/**
 * Bootstrap the agents list once for avatar / system-agent resolution.
 * Safe to call from multiple components — store dedupes concurrent fetches.
 */
export default function useEnsureAgentsLoaded(enabled = true) {
  const ensureAgentsLoaded = useAgentStore((state) => state.ensureAgentsLoaded);

  useEffect(() => {
    if (enabled) {
      ensureAgentsLoaded();
    }
  }, [enabled, ensureAgentsLoaded]);
}
